export enum Privilege {
    SEARCH_ENTITY,
    USER_MANAGEMENT
}